import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=b66b446c&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=b66b446c&prod&lang=scss&scoped=true"
import style1 from "./Footer.vue?vue&type=style&index=1&id=b66b446c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66b446c",
  null
  
)

export default component.exports